import {
  TimeTrackingAssignment,
  TimeTracking,
  TimeTrackingDayEntry,
} from 'src/tabs/models/TimesheetsInterface';
import { TimeSheetsTableBodyCell } from '../Cells/TimesheetsTableBodyCell';
import { getWeeklyHours } from '../utils/getSumHours';
import { TableRowBody } from '../Rows/styles/TimesheetsBodyRow.styled';

interface TimeSheetsBodyRowProps {
  assignmentData?: TimeTracking;
  assignmentInfo?: TimeTrackingAssignment;
  getAssignments?: () => void;
  assignmentType?: number;
  anyPopupsOpen?: boolean;
  setAnyPopupsOpen?: (value: boolean) => void;
}

const ASSIGNMENT_NON_BILLABLE_PROJECT_TYPE = 100_000_001;

export const MobileTimeSheetsBodyRow = ({
  assignmentData,
  assignmentType,
  getAssignments,
  assignmentInfo,
  anyPopupsOpen,
  setAnyPopupsOpen,
}: TimeSheetsBodyRowProps) => {
  const weeklyHours = assignmentData && getWeeklyHours(assignmentData);

  return (
    <TableRowBody>
      {assignmentInfo ? (
        <TimeSheetsTableBodyCell title={assignmentInfo.new_title} />
      ) : (
        <>
          {assignmentData.dayEntries.map(
            (dayEntryData: TimeTrackingDayEntry, index) => {
              return (
                <TimeSheetsTableBodyCell
                  assignmentId={assignmentData.assignment.new_axsassignmentid}
                  timeTrackingId={dayEntryData?.new_axstimetrackingdayentryid}
                  description={dayEntryData?.new_description}
                  date={dayEntryData?.new_date}
                  hours={dayEntryData?.new_actualhours || null}
                  forecastedHours={dayEntryData?.new_forecastedsupplyallocation}
                  assignmentType={assignmentType}
                  statecode={dayEntryData?.statecode}
                  status={dayEntryData?.statuscode}
                  dayType={dayEntryData?.new_daytype}
                  showHourPills={
                    assignmentType <= ASSIGNMENT_NON_BILLABLE_PROJECT_TYPE &&
                    dayEntryData?.new_daytype <
                      ASSIGNMENT_NON_BILLABLE_PROJECT_TYPE
                  }
                  index={index}
                  key={dayEntryData.new_axstimetrackingdayentryid}
                  getAssignments={getAssignments}
                  anyPopupsOpen={anyPopupsOpen}
                  setAnyPopupsOpen={setAnyPopupsOpen}
                  assignment={assignmentData.assignment}
                />
              );
            }
          )}
          <TimeSheetsTableBodyCell weeklyHours={weeklyHours} index={7} />
        </>
      )}
    </TableRowBody>
  );
};
